module.exports = __webpack_public_path__ + "static/media/empty-requests.00269844.svg";